var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6qu0lmcj7a",
    d: "M18.09 16.91l-4.495-4.493C14.502 11.253 15 9.832 15 8.333c0-1.78-.694-3.455-1.953-4.713-1.259-1.26-2.933-1.953-4.714-1.953-1.78 0-3.455.693-4.713 1.953-1.26 1.258-1.953 2.933-1.953 4.713 0 1.781.694 3.455 1.953 4.714C4.878 14.307 6.553 15 8.333 15c1.5 0 2.92-.497 4.084-1.405l4.494 4.493 1.178-1.177zm-9.757-3.577c-1.336 0-2.59-.52-3.535-1.464-.945-.944-1.465-2.2-1.465-3.536 0-1.335.52-2.59 1.465-3.535.944-.945 2.2-1.465 3.535-1.465 1.336 0 2.591.52 3.535 1.465.945.944 1.465 2.2 1.465 3.535 0 1.336-.52 2.592-1.465 3.536-.944.944-2.199 1.464-3.535 1.464z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-780 -205) translate(468 199) translate(312 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0 20 20 0 20z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "4rul3iuzfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6qu0lmcj7a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.87,
    mask: "url(#4rul3iuzfb)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.117cba93c55c685f829492db7937b710.svg";
export { ForwardRef as ReactComponent };